import React from 'react'

export const FullScreenIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="26px"
  >
    <defs>
      <filter id="shadow">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="1.5"
          floodColor="rgba(0,0,0,0.4)"
        />
      </filter>
    </defs>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 7.02907C0.75 3.56124 3.56124 0.75 7.02907 0.75H16.9709C20.4388 0.75 23.25 3.56124 23.25 7.02907V16.9709C23.25 20.4388 20.4388 23.25 16.9709 23.25H7.02907C3.56124 23.25 0.75 20.4388 0.75 16.9709V7.02907ZM4 6.56667C4 5.14914 5.14914 4 6.56667 4H10.3C10.6866 4 11 4.3134 11 4.7C11 5.0866 10.6866 5.4 10.3 5.4H6.56667C5.92233 5.4 5.4 5.92233 5.4 6.56667V10.3C5.4 10.6866 5.0866 11 4.7 11C4.3134 11 4 10.6866 4 10.3V6.56667ZM20 6.56667C20 5.14914 18.8509 4 17.4333 4L13.7 4C13.3134 4 13 4.3134 13 4.7C13 5.0866 13.3134 5.4 13.7 5.4H17.4333C18.0777 5.4 18.6 5.92233 18.6 6.56667V10.3C18.6 10.6866 18.9134 11 19.3 11C19.6866 11 20 10.6866 20 10.3V6.56667ZM20 17.4333C20 18.8509 18.8509 20 17.4333 20H13.7C13.3134 20 13 19.6866 13 19.3C13 18.9134 13.3134 18.6 13.7 18.6H17.4333C18.0777 18.6 18.6 18.0777 18.6 17.4333V13.7C18.6 13.3134 18.9134 13 19.3 13C19.6866 13 20 13.3134 20 13.7V17.4333ZM6.56667 20C5.14914 20 4 18.8509 4 17.4333L4 13.7C4 13.3134 4.3134 13 4.7 13C5.0866 13 5.4 13.3134 5.4 13.7L5.4 17.4333C5.4 18.0777 5.92233 18.6 6.56667 18.6H10.3C10.6866 18.6 11 18.9134 11 19.3C11 19.6866 10.6866 20 10.3 20H6.56667Z"
      fill="white"
      filter="url(#shadow)"
    />
  </svg>
)
